var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6328 24V13.8795H9.20251V24H12.6328ZM10.9181 12.4969C12.1143 12.4969 12.8589 11.7198 12.8589 10.7486C12.8366 9.75556 12.1144 9 10.9408 9C9.76743 9 9.00012 9.75558 9.00012 10.7486C9.00012 11.7198 9.74452 12.4969 10.8957 12.4969H10.918H10.9181ZM14.5315 24H17.9618V18.3482C17.9618 18.0458 17.9841 17.7436 18.0746 17.5274C18.3226 16.923 18.8871 16.2971 19.8346 16.2971C21.0759 16.2971 21.5725 17.2252 21.5725 18.5857V23.9999H25.0026V18.1969C25.0026 15.0883 23.3103 13.6419 21.0533 13.6419C19.2028 13.6419 18.3903 14.6563 17.939 15.3471H17.9619V13.8793H14.5315C14.5766 14.829 14.5315 23.9998 14.5315 23.9998L14.5315 24Z",
    fill: "#192031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white",
    transform: "translate(9.00012 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2516e34292677220aeae0537fdfecd69.svg";
export { ForwardRef as ReactComponent };